
<template>
  <div class="all-wrapper solid-bg-all">
    <div class="layout-w">
      <div class="content-w" style="height: 100%; min-height: 700px;">

        <div class="layout-w">
          <AsideHHComponent/>

          <div class="content-w pt-md-5">
            <div class="content-i">
            <router-view/>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- /.site-footer -->
      </div>
      <!--Version /-->
      <!-- /#right-panel -->
    </div>
  </div>
</template>

<script>

import AsideHHComponent from "@/layouts/globals/AsideHHComponent.vue";

export default {
  components: {
    AsideHHComponent,
  },
  data: () => ({
    drawer: null
  }),
  props: {
    source: String
  },
  created() {
    $("body").removeClass("auth-wrapper");
    $("body").addClass("menu-side-left");
    $("body").addClass("menu-position-side");
    $("body").addClass("full-screen");
  },
};
</script>

<style lang="scss">
</style>
